module.exports = __webpack_public_path__ + "static/media/clap.ad747185.mp3";